export default {
  title: 'Allergenen',
  description: 'Let op: dit {{product}} kan de volgende ingrediënten of producten daarvan bevatten:',
  options: {
    dairy: 'Zuivel/Melk',
    eggs: 'Eieren',
    fish: 'Vis',
    gluten: 'Gluten',
    mango: 'Mango',
    peanuts: "Pinda's",
    sesame: 'Sesam',
    shellfish: 'Schaal- en schelpdieren',
    soy: 'Soja',
    tree_nuts: 'Boomnoten',
    celery: 'Selderij',
    crustaceans: 'Schaaldieren',
    lupin: 'Lupine',
    molluscs: 'Weekdieren',
    mustard: 'Mosterd',
    nuts: 'Noten',
    sulphites: 'Sulfiet',
    almonds: 'Amandelen',
    barley: 'Gerst',
    brazil_nuts: 'Paranoten',
    cashew: 'Cashewnoten',
    hazelnuts: 'Hazelnoten',
    kamut: 'Kamut',
    macadamia: 'Macadamianoten',
    oats: 'Haver',
    pecan: 'Pecannoten',
    pistachios: 'Pistachenoten',
    rye: 'Rogge',
    spelt: 'Spelt',
    walnuts: 'Walnoten',
    wheat: 'Tarwe',
    sugared_drink: 'Suikerhoudende drank',
    lentils: 'Linzen',
    queensland_nuts: 'Queenslandnoten',
  },
};
